import Css from "./style.module.scss";

import { getAccountsData } from "selectors/accounts";
import { getSelectedBusinessId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useMainApi } from "hooks";
import { useSelector } from "react-redux";
import IntegrationServices from "const/IntegrationServices";
import MultiSelect from "nlib/ui/MultiSelect";
import React, { useMemo } from "react";
import UiRoutes from "const/UiRoutes";

const SelectExcludedAccounts = ({
  value,
  disabled,
  businessId,
  integrationService,
  onChange,
  ...restProps
}) => {
  const { uiTexts } = useSelector(getTextsData);

  const selectedBusinessId = useSelector(getSelectedBusinessId);

  const quickBooksBusiness = integrationService === IntegrationServices.QUICK_BOOKS.value;

  const storedAccountsData = useSelector(getAccountsData);

  const [{ results: accountsData }, fetching] = useMainApi({
    fetchCondition: selectedBusinessId !== businessId,
    initialData: { results: storedAccountsData },
    parameters: [`${UiRoutes.BUSINESSES}/${businessId}${UiRoutes.ACCOUNTS}`]
  });

  const accountsNames = useMemo(() => {
    return accountsData
      .filter(({ extraData: { paymentAccount } = {} }) => !quickBooksBusiness || paymentAccount)
      .map(({ name }) => ({ value: name, label: name }));
  }, [quickBooksBusiness, accountsData]);

  return (
    <div className={Css.selectExcludedAccounts}>
      <MultiSelect
        value={value}
        disabled={disabled || (selectedBusinessId !== businessId && fetching)}
        className={Css.input}
        invalid={!value.length}
        options={accountsNames}
        onChange={onChange}
        placeholder={(selectedBusinessId !== businessId && fetching) ? `${uiTexts.loading}...` : uiTexts.enterAccountName}
        {...restProps} />
    </div>
  );
};

export default React.memo(SelectExcludedAccounts);
